import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ApiConfig } from './config/api.config';
import { AppointmentAvalaible } from '../models/appointment-avalaible.model';
import { AppointmentAutomatic } from '../models/appointment-automatic.model';
import { GenerateMedicalAppointment } from '../models/generate-medical-appointment.model';
import { Appointment } from '../models/appointment.model';
import { AppointmentAvalaibleResponse } from '../models/appointment-avalaible-response.model';

@Injectable()
export class AppointmentService{

    constructor(
        private http: HttpClient,
        private api: ApiConfig    
    ){}   

    getAvailables(cadena: string) : Observable<Array<AppointmentAvalaible>>{
        return this.http.get<Array<AppointmentAvalaible>>(this.api.url + '/appointments/availables/' + cadena);
    }

    getAvailablesPanacea(cadena: string) : Observable<Array<AppointmentAvalaible>>{
        return this.http.get<Array<AppointmentAvalaible>>(this.api.url + '/appointments/availables_panacea/' + cadena);
    }

    getAvailablesSpecialtyLenderPanacea(document: string, codSpecialty: string, codCity: string, reschedule: number, codLender: string) : Observable<AppointmentAvalaibleResponse>{
        return this.http.get<AppointmentAvalaibleResponse>(this.api.url + '/appointments/availables_panacea/' + document + '/' + codSpecialty + '/' + codCity + '/' + reschedule + '/' + codLender);
        //return this.http.get<Array<AppointmentAvalaible>>(this.api.url + '/appointments/availables_panacea/1/184/1/' + codLender);
    }

    getMedicalAppointments(identificacion : string): Observable<Array<Appointment>>{
        return this.http.get<Array<Appointment>>(this.api.url + '/appointments/' + identificacion);
    }

    getMedicalAppointmentsPanacea(identificacion : string): Observable<Array<Appointment>>{
        return this.http.get<Array<Appointment>>(this.api.url + '/appointments/panacea/' + identificacion);
    }

    getAppointment30days(documentType: string, document: string, cardNumber : string) : Observable<Array<AppointmentAutomatic>>{
        return this.http.get<Array<AppointmentAutomatic>>(this.api.url + '/appointments/' + documentType + '/' + document + '/' + cardNumber);
    }

    postGeneraCitaMedica(obj : GenerateMedicalAppointment) : Observable<any>{
        return this.http.post<any>(this.api.url + '/appointments', obj); 
    }

    postGeneraCitaMedicaPanacea(obj : GenerateMedicalAppointment) : Observable<any>{
        return this.http.post<any>(this.api.url + '/appointments/panacea', obj); 
    }

    getValidaFechaCancelacion(fecha : string) : Observable<boolean>{
        return this.http.get<boolean>(this.api.url + '/appointments?fecha=' + fecha); 
    }

    putCancelaCitaMedica(obj: any) : Observable<any>{
        return this.http.put<any>(this.api.url + '/appointments', obj); 
    }

    putCancelaCitaMedicaPanacea(obj: any) : Observable<any>{
        return this.http.put<any>(this.api.url + '/appointments/panacea', obj); 
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/appointment.service.ts